import { render, staticRenderFns } from "./CmgOrderConfirmationHeaderMap.vue?vue&type=template&id=4c59a86a&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-header-map.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-header-map.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationHeaderMap.vue?vue&type=style&index=0&id=4c59a86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c59a86a",
  null
  
)

export default component.exports